import { render, staticRenderFns } from "./PolicyAgree.vue?vue&type=template&id=b268c382&"
import script from "./PolicyAgree.vue?vue&type=script&lang=js&"
export * from "./PolicyAgree.vue?vue&type=script&lang=js&"
import style0 from "./PolicyAgree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VCardText,VCardTitle,VCheckbox,VChip})
